import React from 'react'

import Routes from 'Routes'

import './app.scss'

function App() {
	return (
		<div className='app'>
			<Routes />
		</div>
	)
}

export default App
